import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  padding-top: 3.5rem;
  overflow: auto;
  padding-bottom: 6.5rem;
  @media (max-height: 840px){
    padding-bottom: 0;
  }
`;